<mat-accordion>
  <mat-expansion-panel style="background-color: rgb(31, 33, 49);" hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Candidatos
      </mat-panel-title>
      <mat-panel-description>


      </mat-panel-description>
    </mat-expansion-panel-header>

    <mat-selection-list [multiple]="false">
      <div *ngIf="role==1; then admin else recruiter">
      </div>
      <ng-template #admin>
        <div *ngFor="let user of candidates" style="color: rgb(80, 188, 255);">
          {{user.recruiter_name | titlecase}} {{user.recruiter_lastname | titlecase}}
          <div *ngFor="let candidate of user.candidates">
            <mat-list-option (click)="onSelect(candidate.id)">
              {{candidate.name | titlecase}} {{candidate.lastname | titlecase}}
            </mat-list-option>
          </div>
        </div>
      </ng-template>

      <ng-template #recruiter>
        <div *ngFor="let candidate of candidates">
          <mat-list-option (click)="onSelect(candidate.id)">
            {{candidate.name | titlecase}} {{candidate.lastname | titlecase}}
          </mat-list-option>
        </div>
      </ng-template>

    </mat-selection-list>


  </mat-expansion-panel>
</mat-accordion>